<template>
    <section class="panel panel-featured-left panel-featured-primary">
        <div class="panel-body">
            <div class="widget-summary">
                <div class="widget-summary-col widget-summary-col-icon">
                    <div class="summary-icon bg-primary">
                        <i class="fa fa-list"></i>
                    </div>
                </div>
                <div class="widget-summary-col">
                    <div class="summary">
                        <h4 class="title">Métodos de Pago</h4>
                        <p>Le recordamos nuestras Formas de Pago:</p>
                        <ul>
                            <li>
                                <strong>Transferencia Electrónica o Depósito en el Banco</strong>
                                <p>
                                    Banco: Banamex<br />
                                    Sucursal: 933<br />
                                    Tipo: Cuenta de Cheques<br />
                                    CLABE: 002150701060279251<br />
                                    Número de Cuenta: 70106027925<br />
                                    Método de pago: 03 – Transferencia electrónica de fondos
                                </p>
                            </li>
                            <li>
                                <strong>Tarjeta de Crédito o Débito</strong>
                                <p>Directamente en nuestras oficinas ubicadas en:<br />Calle Georgia 3100-A,<br />Colonia Las Águilas,<br />Chihuahua, Chihuahua, México.</p>
                            </li>
                            <li>
                                <strong>PAYPAL</strong>
                                <p>Requiere solicitud, favor de enviar mensaje.</p>
                            </li>
                        </ul>
                    </div>
                    <div class="summary-footer">
                        <router-link class="text-muted text-uppercase" to="/features/contact">
                            (enviar mensaje)
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    module.exports = {
        name: 'payment-methods',
        data: function () {
            return {
                isLoading: true
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.refresh();
            });
        },
        methods: {
            refresh: function () {
                this.isLoading = false;
            }
        }
    }
</script>